function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#F0F0F0"
}), React.createElement("path", {
  d: "M8.00014 0V8L2.34326 13.6569C3.79098 15.1046 5.79098 16 8.00014 16C12.4184 16 16.0001 12.4183 16.0001 8C16.0001 3.58175 8.00014 0 8.00014 0Z",
  fill: "#D80027"
}), React.createElement("path", {
  d: "M8.00014 0C5.79098 0 3.79098 0.895438 2.34326 2.34313C4.30607 4.30594 5.00286 5.00275 8.00014 8H16.0001C16.0001 3.58175 12.4184 0 8.00014 0Z",
  fill: "#0052B4"
}), React.createElement("path", {
  d: "M5.4775 8.00007L4.5005 7.5405L5.02078 6.59428L3.95984 6.79725L3.82541 5.72546L3.08641 6.51372L2.34744 5.72546L2.21297 6.79725L1.15206 6.59425L1.67234 7.5405L0.695312 8.00007L1.67234 8.45963L1.15206 9.40585L2.21306 9.20291L2.34741 10.2747L3.08641 9.48641L3.82541 10.2747L3.95984 9.20291L5.02072 9.40588L4.50047 8.45966L5.4775 8.00007Z",
  fill: "#FFDA44"
}), React.createElement("path", {
  d: "M2.13307 3.13049L2.45819 3.58496L2.99085 3.41624L2.65904 3.86586L2.98416 4.32033L2.45397 4.14374L2.12219 4.59333L2.12635 4.03458L1.59619 3.85796L2.12894 3.68924L2.13307 3.13049Z",
  fill: "#FFDA44"
}), React.createElement("path", {
  d: "M2.13307 11.4069L2.45819 11.8613L2.99085 11.6926L2.65904 12.1422L2.98416 12.5967L2.45397 12.4201L2.12219 12.8697L2.12635 12.311L1.59619 12.1343L2.12894 11.9656L2.13307 11.4069Z",
  fill: "#FFDA44"
}), React.createElement("path", {
  d: "M6.77038 7.26868L6.44529 7.72315L5.9126 7.55436L6.24441 8.00402L5.91929 8.45852L6.44947 8.2819L6.78129 8.73149L6.7771 8.17277L7.30725 7.99615L6.77454 7.82743L6.77038 7.26868Z",
  fill: "#FFDA44"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));
const SvgPhilippines = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgPhilippines, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/philippines.2c908a36.svg";
export { ForwardRef as ReactComponent };